'use strict';
import React from 'react';
import RadioButtonList from '../components/Common/RadioButtonList.jsx';
import ClientApplicationStore from '../stores/ClientApplicationStore.js';
import ApplicationActions from '../actions/ApplicationActions.js';
import { SpinnerSizes, ProductIds } from '../constants/ApplicationConstants';
import Spinner from './Common/Spinner.jsx';
import _ from 'lodash';
import autoBind from 'react-autobind';
import Transitions from '../core/Transitions';
import Mapper from '../utils/Mapper.js';
import Products from '../utils/Products.js';
import SlidingSessionNotification from './SlidingSessionNotification.jsx';
import OmnitureTracking from '../utils/OmnitureTracking.js';
import { withRouter } from 'react-router';

function getStateFromStore() {
  var products = ClientApplicationStore.getProductList();
  return {
    productList: Mapper.arrayOfObjectMapper(products, {value: 'id', label: 'name'}),
    isAdviserRegisteredAnnuity:
      ClientApplicationStore.getIsAdviserRegisteredAnnuity(),
    clientOin: ClientApplicationStore.getClientOin(),
    isExisting: ClientApplicationStore.isExisting(),
    shouldNavigateToAcquisition: ClientApplicationStore.shouldNavigateToAcquisition()
  };
}

class ClientApplication extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = _.assign(getStateFromStore(), {
      isAnnuityCheckComplete: true
    });
  }

  routeToApplicationForm() {
    Transitions.forwardFromSelectProduct(this.props.router);
  }

  productChanged(e) {
    var productId = parseInt(e.target.value);
    if (productId === ProductIds.SUPER && this.state.shouldNavigateToAcquisition) {
      ApplicationActions.navigateToAcquisition();
      return;
    }

    //Save selected product in ApplicationStore
    ApplicationActions.setProductId(productId);
    // initialize new application
    ApplicationActions.createNewApplication(productId, this.state.clientOin);

    if (Products.isAnnuity(productId)) {
      this.setState({ isAnnuityCheckComplete: false });
      ApplicationActions.getIsProductRegistered(productId);
    } else {
      //All other product, go directly to application form
      this.routeToApplicationForm();
    }
  }

  // Add change listeners to stores
  componentDidMount() {
    OmnitureTracking.getTrackingEnabled();

    const query = this.props.location.query || {};
    const pid = query['p_id'];
    //auto product selection for investment public
    if (this.state.isExisting === false && pid === ProductIds.INVESTMENT.toString()) {
      this.productChanged({ target: { value: pid } });
      return;
    }

    ClientApplicationStore.addChangeListener(this._onChange);
  }

  // Remove change listers from stores
  componentWillUnmount() {
    ClientApplicationStore.removeChangeListener(this._onChange);
  }

  //Event handler for 'change' events coming from the stores
  _onChange() {
    this.setState(getStateFromStore());
  }

  componentWillUpdate(nextProps, nextState) {
    if (!this.state.isAnnuityCheckComplete) {
      if (nextState.isAdviserRegisteredAnnuity) {
        //if adviser is registered to CommInsure/Challenger annuity, go to application form
        this.routeToApplicationForm();
        this.setState({ isAnnuityCheckComplete: true });
      } else {
        //Redirect to FNA product registration
        window.location.replace(
          window.NOA.configuration.annuityRegistrationUrl
        );
      }
    }
  }

  render() {
    return (
      <div className="start">
        {this.state.isAnnuityCheckComplete ? (
          <a onClick={this.props.history.goBack} className="icon icon-up-open-big"></a>) : null}
        <div className="container">
          <SlidingSessionNotification />
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <Spinner hide={this.state.isAnnuityCheckComplete} size={SpinnerSizes.Three}/>
              {this.state.isAnnuityCheckComplete ? (
                <RadioButtonList
                  data={this.state.productList}
                  handleChange={this.productChanged}
                  id="productList"
                  label="Select application"
                  name="productList"
                  useHeadingStyle={true}
                  value={this.state.productList.product}/>) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ClientApplication);


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/ClientApplication.jsx